module.exports = __webpack_public_path__ + "img/referencia-personal.e41148be.png";